<payment-shared [customerID]="customerID" [rentalServiceDeliveryChannel]="rentalServiceDeliveryChannel" [caseID]="caseID" [depositeType]="depositeType" [paymentMode]="paymentMode" [paymentValue]="paymentValue" ></payment-shared>
